import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { WindowService } from 'src/app/common/service/window.service';

@Component({
  selector: 'app-infinite-slider',
  templateUrl: './infinite-slider.component.html',
  styleUrl: './infinite-slider.component.scss'
})
export class InfiniteSliderComponent implements OnInit, AfterViewInit {

  baseItems: string[] = [
    'infinite_slider_Data1',
    'infinite_slider_Data2',
    'infinite_slider_Data3',
    'infinite_slider_Data4',
    'infinite_slider_Data5',
    'infinite_slider_Data6',
  ];
  allItems: string[] = [];
  repeatCount: number = 6;

  @ViewChild('itemsContainer') itemsContainer!: ElementRef;

  constructor(
    private windowService: WindowService,
  ) { }

  ngOnInit(): void {
    this.populateItems();
  }

  ngAfterViewInit() {
    const container = this.itemsContainer.nativeElement as HTMLElement;

    container.addEventListener('wheel', e => e.preventDefault(), { passive: false });
    container.addEventListener('touchmove', e => e.preventDefault(), { passive: false });

    this.startSlider();
  }

  /**
   * Añade los items del scroll
   */
  populateItems() {
    for (let i = 0; i < this.repeatCount; i++) {
      this.allItems.push(...this.baseItems);
    }
  }

  /**
   * Empieza el slider a mvoerse
   */
  startSlider() {
    if (this.windowService.isBrowser) {
      const container = this.itemsContainer.nativeElement as HTMLElement;
      let totalWidth = container.scrollWidth / 2;

      let position = 0;

      const animateSlider = () => {
        position -= 0.5; //
        if (Math.abs(position) >= totalWidth) {
          position = 0;
        }
        container.style.transform = `translateX(${position}px)`;
        requestAnimationFrame(animateSlider);
      };
      requestAnimationFrame(animateSlider);
    }
  }
}
